import { type SessionVerdictResponse, type SessionVerdictRow } from '../../services/api/judge';

export type ReadableVerdictRow = SessionVerdictRow & {
  verdict: NonNullable<SessionVerdictRow['verdict']>;
};

export type SessionVerdictView = {
  failure: (NonNullable<SessionVerdictRow['failure']> & { attempts: number }) | null;
  shown: ReadableVerdictRow | null;
  unreadablePromptVersion: string | null;
  notJudgedYet: boolean;
};

const isReadable = (row: SessionVerdictRow | null): row is ReadableVerdictRow =>
  row !== null && row.verdict !== null;

const isUnreadable = (row: SessionVerdictRow | null): row is SessionVerdictRow =>
  row !== null && row.status === 'succeeded' && row.verdict === null;

// En lyckad dom utan läsbart innehåll har klarat skrivningen men inte serverns
// tolkning. Den ska synas som just det, annars ser panelen tom ut som om inget
// hade hänt med sessionen.
export const sessionVerdictView = (data: SessionVerdictResponse): SessionVerdictView => {
  const { requested, latestSucceeded } = data;
  const shown = [requested, latestSucceeded].find(isReadable) ?? null;
  const unreadable = isUnreadable(requested)
    ? requested
    : !shown && isUnreadable(latestSucceeded)
      ? latestSucceeded
      : null;
  const failure =
    requested?.status === 'failed' && requested.failure
      ? { ...requested.failure, attempts: requested.attempts }
      : null;
  return {
    failure,
    shown,
    unreadablePromptVersion: unreadable?.promptVersion ?? null,
    notJudgedYet: !failure && !shown && !unreadable,
  };
};
